'use client'

import { MessageCircle } from 'lucide-react'
import { SITE } from '@/lib/site'

export default function WhatsAppWidget() {
  return (
    <a
      href={SITE.whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp ile yazın"
      className="fixed bottom-5 right-5 z-50 w-12 h-12 min-w-[48px] min-h-[48px] rounded-full bg-[#0f766e] hover:bg-[#0d9488] text-white shadow-lg flex items-center justify-center"
    >
      <MessageCircle size={24} />
    </a>
  )
}
